const $window = $(window);
const breakpointDesktop = require("./utils/breakpoints.json").pd_desktop;

export const elements = {
    imagesTextContainer: ".image-text-container"
};
export const breakpoints = {
    desktop: breakpointDesktop
};

/**
 *  Check if large breakpoints
 *  @returns {boolean} - current breakpoint is desktop
 */
const isDesktop = () => {
    if ($window.width() > breakpoints.desktop) {
        return true;
    }

    return false;
};

/**
 *  Get padding for breakpoint
 *  @param {Object} el - selector for element
 */
const getPadding = (el) => {
    var paddingTop = "0rem";
    var paddingBottom = "0rem";
    var paddingLeft = "0rem";
    var paddingRight = "0rem";
    if (isDesktop()) {
        paddingTop = el.data("padding-top-large") ? el.data("padding-top-large") : paddingTop;
        paddingBottom = el.data("padding-bottom-large") ? el.data("padding-bottom-large") : paddingBottom;
        paddingLeft = el.data("padding-left-large") ? el.data("padding-left-large") : paddingLeft;
        paddingRight = el.data("padding-right-large") ? el.data("padding-right-large") : paddingRight;
    } else {
        paddingTop = el.data("padding-top-small") ? el.data("padding-top-small") : paddingTop;
        paddingBottom = el.data("padding-bottom-small") ? el.data("padding-bottom-small") : paddingBottom;
        paddingLeft = el.data("padding-left-small") ? el.data("padding-left-small") : paddingLeft;
        paddingRight = el.data("padding-right-small") ? el.data("padding-right-small") : paddingRight;
    }

    el.css("padding-top", paddingTop);
    el.css("padding-bottom", paddingBottom);
    el.css("padding-left", paddingLeft);
    el.css("padding-right", paddingRight);
};

/**
 *  Get padding for columns breakpoint
 *  @param {Object} el - selector for element
 */
const getColumnsPadding = (el) => {
    var columns1PaddingTopAndBottom = "0rem";
    var columns1PaddingRightAndLeft = "0rem";
    var columns2PaddingTopAndBottom = "0rem";
    var columns2PaddingRightAndLeft = "0rem";
    var columns3PaddingTopAndBottom = "0rem";
    var columns3PaddingRightAndLeft = "0rem";
    var columns4PaddingTopAndBottom = "0rem";
    var columns4PaddingRightAndLeft = "0rem";
    if (isDesktop()) {
        columns1PaddingTopAndBottom = el.data("columns-1-padding-top-bottom-large") ? el.data("columns-1-padding-top-bottom-large") : columns1PaddingTopAndBottom;
        columns1PaddingRightAndLeft = el.data("columns-1-padding-left-right-large") ? el.data("columns-1-padding-left-right-large") : columns1PaddingRightAndLeft;
        columns2PaddingTopAndBottom = el.data("columns-2-padding-top-bottom-large") ? el.data("columns-2-padding-top-bottom-large") : columns2PaddingTopAndBottom;
        columns2PaddingRightAndLeft = el.data("columns-2-padding-left-right-large") ? el.data("columns-2-padding-left-right-large") : columns2PaddingRightAndLeft;
        columns3PaddingTopAndBottom = el.data("columns-3-padding-top-bottom-large") ? el.data("columns-3-padding-top-bottom-large") : columns3PaddingTopAndBottom;
        columns3PaddingRightAndLeft = el.data("columns-3-padding-left-right-large") ? el.data("columns-3-padding-left-right-large") : columns3PaddingRightAndLeft;
        columns4PaddingRightAndLeft = el.data("columns-4-padding-left-right-large") ? el.data("columns-4-padding-left-right-large") : columns4PaddingRightAndLeft;
        columns4PaddingRightAndLeft = el.data("columns-4-padding-left-right-large") ? el.data("columns-4-padding-left-right-large") : columns4PaddingRightAndLeft;

    } else {
        columns1PaddingTopAndBottom = el.data("columns-1-padding-top-bottom-small") ? el.data("columns-1-padding-top-bottom-small") : columns1PaddingTopAndBottom;
        columns1PaddingRightAndLeft = el.data("columns-1-padding-left-right-small") ? el.data("columns-1-padding-left-right-small") : columns1PaddingRightAndLeft;
        columns2PaddingTopAndBottom = el.data("columns-2-padding-top-bottom-small") ? el.data("columns-2-padding-top-bottom-small") : columns2PaddingTopAndBottom;
        columns2PaddingRightAndLeft = el.data("columns-2-padding-left-right-small") ? el.data("columns-2-padding-left-right-small") : columns2PaddingRightAndLeft;
        columns3PaddingTopAndBottom = el.data("columns-3-padding-top-bottom-small") ? el.data("columns-3-padding-top-bottom-small") : columns3PaddingTopAndBottom;
        columns3PaddingRightAndLeft = el.data("columns-3-padding-left-right-small") ? el.data("columns-3-padding-left-right-small") : columns3PaddingRightAndLeft;
        columns4PaddingTopAndBottom = el.data("columns-4-padding-top-bottom-small") ? el.data("columns-4-padding-top-bottom-small") : columns4PaddingTopAndBottom;
        columns4PaddingRightAndLeft = el.data("columns-4-padding-left-right-small") ? el.data("columns-4-padding-left-right-small") : columns4PaddingRightAndLeft;
    }

    if (el.hasClass("region-1")) {
        el.css("padding-top", columns1PaddingTopAndBottom);
        el.css("padding-bottom", columns1PaddingTopAndBottom);
        el.css("padding-left", columns1PaddingRightAndLeft);
        el.css("padding-right", columns1PaddingRightAndLeft);
    }

    // column 2
    if (el.hasClass("region-2")) {
        el.css("padding-top", columns2PaddingTopAndBottom);
        el.css("padding-bottom", columns2PaddingTopAndBottom);
        el.css("padding-left", columns2PaddingRightAndLeft);
        el.css("padding-right", columns2PaddingRightAndLeft);
    }

    // column 3
    if (el.hasClass("region-3")) {
        el.css("padding-top", columns3PaddingTopAndBottom);
        el.css("padding-bottom", columns3PaddingTopAndBottom);
        el.css("padding-left", columns3PaddingRightAndLeft);
        el.css("padding-right", columns3PaddingRightAndLeft);
    }

    // column 4
    if (el.hasClass("region-4")) {
        el.css("padding-top", columns4PaddingTopAndBottom);
        el.css("padding-bottom", columns4PaddingTopAndBottom);
        el.css("padding-left", columns4PaddingRightAndLeft);
        el.css("padding-right", columns4PaddingRightAndLeft);
    }
};

/**
 * Set padding for mobile
 */
const setPadding = () => {
    var $layoutContainer = $(".layout-container");
    if ($layoutContainer.length > 0) {
        $layoutContainer.each(function () {
            getPadding($(this));
        });
    }
};

/**
 * Set padding for columns mobile
 */
function setColumnsPadding() {
    var $columnsContainer = $(".col-container");
    if ($columnsContainer.length > 0) {
        $columnsContainer.each(function () {
            getColumnsPadding($(this));
        });
    }
}

/**
 *  Get margin for cta breakpoint
 *  @param {Object} el - selector for element
 */
const getCtaMargins = (el) => {
    var ctaMarginTop = "0rem";
    if (isDesktop()) {
        ctaMarginTop = el.data("cta-margin-top-large") ? el.data("cta-margin-top-large") : ctaMarginTop;
    } else {
        ctaMarginTop = el.data("cta-margin-top-small") ? el.data("cta-margin-top-small") : ctaMarginTop;
    }

    el.css("margin-top", ctaMarginTop);
};

/**
 * Set margin for cta mobile
 */
function setCtaMargins() {
    var $ctaTargeted = $(".layoutCta");
    if ($ctaTargeted.length > 0) {
        $ctaTargeted.each(function () {
            getCtaMargins($(this));
        });
    }
}

/**
 * Set padding for images and text mobile
 */
function setImagesTextPadding() {
    var $imagesTextContainer =  $(elements.imagesTextContainer);
    if ($imagesTextContainer.length > 0) {
        $imagesTextContainer.each(function () {
            getPadding($(this));
        });
    }
}

$(document).ready(function () {
    setPadding();
    setColumnsPadding();
    setCtaMargins();
    setImagesTextPadding();

    $window.on("resize", () => {
        setPadding();
        setColumnsPadding();
        setCtaMargins();
        setImagesTextPadding();
    });
});
